export default __webpack_public_path__ + "static/media/Doubs.833cbf8a.png";